import {getTestProps} from '@benchling/js-test-utils';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import * as Colors from 'ui-library/Colors';

interface AdditionalEditorSectionProps {
  title: string;
  addItemElement: JSX.Element;
  pills: Array<JSX.Element>;
  showTopBorder: boolean;
  className?: string;
}

export default function AdditionalEditorSection({
  title,
  addItemElement,
  pills,
  showTopBorder,
  className,
}: AdditionalEditorSectionProps): JSX.Element {
  return (
    <div
      className={classNames(className, css(additionalEditorSectionStyles.wrapper))}
      {...getTestProps({component: 'AdditionalEditorSection', element: 'root', key: title})}
      data-amp-safe={false}
    >
      <div
        className={css(
          additionalEditorSectionStyles.header,
          showTopBorder && additionalEditorSectionStyles.borderTop
        )}
      >
        {title}
        {addItemElement}
      </div>
      {pills.map((pill, idx) => (
        <div className={idx === 0 ? 'u-small-spacing-top' : 'u-tiny-spacing-top'} key={idx}>
          {pill}
        </div>
      ))}
    </div>
  );
}

export const additionalEditorSectionStyles = StyleSheet.create({
  wrapper: {
    padding: '4px 12px',
  },
  header: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    color: Colors.GRAY_DARKER,
    paddingTop: 8,
  },
  borderTop: {
    borderTop: `1px solid ${Colors.GRAY_LIGHT}`,
  },
});
